import { faExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TOsiraseGetListRes } from "../../../service/master/osirase/TOsirase"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

export const OsiraseTemplateCell =
  (onClickEventHandler: (cellData: TOsiraseGetListRes) => unknown) =>
  (context: TWijmoCellTemplateContext<TOsiraseGetListRes>) => {
    let spanClassName = ""
    let iconClassName = "mx-1"

    if (context.item.強調表示フラグ) {
      spanClassName += " text-danger"
      iconClassName += " visible"
    } else {
      iconClassName += " invisible"
    }

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
        }}>
        <span
          onClick={(e) => onClickEventHandler(context.item)}
          className={spanClassName}
          style={{ textDecoration: "underline", cursor: "pointer" }}>
          <FontAwesomeIcon
            icon={faExclamation}
            className={iconClassName}></FontAwesomeIcon>
          {context.item.タイトル}
        </span>
      </div>
    )
  }
